export default "__VITE_ASSET__CI44l6k3__"